'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-features',
    cnList = "".concat(CLASSNAME, "__list"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnButton = "".concat(CLASSNAME, "__button");
/**
 * 
 */

var Features = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Features, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Features);

  function Features() {
    _rollupPluginBabelHelpers.classCallCheck(this, Features);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(Features, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          items = _this$props.items,
          onClick = _this$props.onClick,
          mobile = _this$props.mobile;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className)
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: cnList
      }, items.map(function (_ref, i) {
        var Icon = _ref.Icon;
        return /*#__PURE__*/React__default.createElement("li", {
          key: i,
          className: cnItem,
          onClick: onClick
        }, /*#__PURE__*/React__default.createElement("img", {
          className: cnIcon,
          src: Icon
        }));
      })), /*#__PURE__*/React__default.createElement("button", {
        className: cnButton,
        onClick: onClick,
        role: "button",
        "aria-label": "Features"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        size: mobile ? 'md' : 'lg',
        id: "info-boxed"
      })));
    }
  }]);

  return Features;
}(React__default.Component);
Features.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Array of items */
  items: PropTypes.array.isRequired,

  /** True for mobile layout */
  mobile: PropTypes.bool,

  /** Callback function */
  onClick: PropTypes.func.isRequired
};
Features.defaultProps = {
  items: [],
  onClick: function onClick() {
    return void 0;
  }
};

module.exports = Features;
